export default {
  namespaced: true,
  state: {
    keyboardHeight: 0, // 键盘高度
  },
  mutations: {
    SET_KEYBOARDHEIGHT (state, value) {
      state.keyboardHeight = value
    }
  },
  actions: {
    setKeyboardHeight ({ commit }, value) {
      commit('SET_KEYBOARDHEIGHT', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js